<template>
  <div class="flex gap-4 items-center z-9 grow relative">
    <Search class="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
    <input
      v-model="searchQuery"
      class="w-full h-9 pl-9 pr-10 rounded-md border-[1px] border-gray-300 bg-white font-normal text-xs"
      type="text"
      :placeholder="placeholder || 'Search'"
      @keyup.enter="handleEnterPress"
      @keyup.escape="handleEscapePress"
    >
    <button 
      v-if="searchQuery" 
      @click="clearSearch"
      class="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
      aria-label="Clear search"
    >
      <X class="w-4 h-4" />
    </button>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import { Search, X } from 'lucide-vue-next'

const props = defineProps({
  modelValue: {
    type: String,
    default: ''
  },
  placeholder: {
    type: String,
    default: 'Search'
  }
})

const emit = defineEmits(['update:modelValue', 'search'])

const route = useRoute()
const searchQuery = ref(props.modelValue || '')

// Initialize search from URL params
onMounted(() => {
  const search = route.query.search
  if (search) {
    searchQuery.value = search
  }
})

// Convert clearSearch from computed to method
const clearSearch = () => {
  searchQuery.value = ''
  emit('update:modelValue', '')
  // Always trigger search when clearing
  emit('search')
}

// Handle Enter key press - trigger search immediately
const handleEnterPress = () => {
  emit('update:modelValue', searchQuery.value)
  emit('search')
}

// Handle Escape key press
const handleEscapePress = () => {
  clearSearch()
}

// Watch for changes in props.modelValue
watch(
  () => props.modelValue,
  (newValue) => {
    if (newValue !== searchQuery.value) {
      searchQuery.value = newValue
    }
  }
)

// Watch for changes in searchQuery
watch(
  searchQuery,
  (newValue) => {
    emit('update:modelValue', newValue)
  }
)
</script>

